import React from 'react';
import { useLocation } from 'react-router-dom';

import { AnalyticsPageView } from '@backrs_ui/common-ui';

import { usePostHogAnalytics } from '../hooks/usePostHogAnalytics';

interface PostHogPageViewShellProps {
  children: React.ReactNode;
}

export const PostHogPageViewShell: React.FC<PostHogPageViewShellProps> = ({ children }) => {
  const location = useLocation();
  const posthog = usePostHogAnalytics();

  return (
    <AnalyticsPageView posthog={posthog} location={location}>
      {children}
    </AnalyticsPageView>
  );
};
